import { ListingFooterViewModel } from 'models';

export function alternateDatesInfo() {
  return {
    collapsedLinkName: 'HSR show alt dates',
    collapsedMsgKey: 'hotels.searchResults.alternateDates.more',
    collapsedRfrr: 'HOT:SR:ShowAltDates',
    expandedLinkName: 'HSR hide alt dates',
    expandedMsgKey: 'hotels.searchResults.alternateDates.less',
    expandedRfrr: 'HOT:SR:HideAltDates',
    headerTextKey: 'hotels.searchResults.alternateDates.try',
  };
}

export const isMemberOnlyDealListingFooter = (listingFooter: ListingFooterViewModel) =>
  listingFooter?.actionModel.actionDetails?.name === 'EXTERNAL_LINK';
